import * as React from 'react';
import ErrorPage from '../../modules/error-page';
import { IErrorPageComponentProps } from '../../modules/error-page/error-page.types';

export default function ErrorScreen(props: IErrorPageComponentProps): JSX.Element {
    return <ErrorPage {...props} />;
}
